import React from 'react'

import { useRemoteStrings } from '@acorns/web-utils'
import styled from 'styled-components'

import AcornsLogoGreenPath from 'assets/logos/acorns-green.svg'
import { Heading2 } from 'components/typography'
import theme from 'theme'
import { ACTION_FEED_FOOTER } from 'utils/testing/testIDs'

const FooterText = styled(Heading2)`
  display: block;
  white-space: nowrap;
  color: ${theme.colors.slate};
`
const Logo = styled.img`
  height: 17px;
  width: auto;
  margin: 2px 10px 4px 0px;
`

const WrappingDiv = styled.div`
  vertical-align: top;
  text-align: left;
  display: flex;
  align-items: center;
`

export const Footer = () => {
  const { getRemoteString } = useRemoteStrings()
  return (
    <WrappingDiv>
      <Logo alt="Acorns Logo" src={AcornsLogoGreenPath} />
      <FooterText data-testid={ACTION_FEED_FOOTER}>
        {getRemoteString({ key: 'action_feed.footer' })}
      </FooterText>
    </WrappingDiv>
  )
}
